import { injectable } from "inversify";
import { Validator } from "vee-validate";
import IValidationService from "./interfaces/validation.service.interface";

@injectable()
export default class ValidationService implements IValidationService {
    public getValidationClass(validator: Validator, fieldName: string): string {

        if (validator.errors.has(fieldName)) {
            return "is-invalid";
        }

        const field = validator.fields.find({ name: fieldName });
        if (field && field.flags && field.flags.valid) {
            return "is-valid";
        }

        return "";
    }
}
